module.exports = __webpack_public_path__ + "static/img/xpcw-header.570a06d1.png";